// extracted by mini-css-extract-plugin
export var getPointsButtonWrapper = "get-points-button-module--get-points-button-wrapper--be77c";